const NodeAction = ({ deleteNode, duplicateNode, isGoal, toggleGoal }) => {
    return (
        <ul style={{
            display: 'flex',
            gap: '5px',
            position: "absolute",
            top: "-25px",
            right: "0px",
            backgroundColor: "white",
            padding: "6px 10px",
            borderRadius: "3px",
            pointerEvents: "all",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
            zIndex: 9999,
        }}
            className="nodrag nopan">
            <li className="action-icon hover-pad"><img src={require("../assets/node/bin.png")} width={12} onClick={deleteNode} /></li>
            <li className="action-icon hover-pad"><img src={require("../assets/node/copy.png")} width={12} onClick={duplicateNode} /></li>
            {/* Unlike the other two this is a toggle, not a one-shot action, so it carries an on-state
                the strip itself has to show — the strip is hover-only, but the goal name field at the
                bottom of the node stays visible as the at-rest indicator. */}
            <li
                className={`action-icon hover-pad${isGoal ? " action-icon-on" : ""}`}
                title={isGoal ? "Remove conversion goal" : "Mark as conversion goal"}
                onClick={toggleGoal}
            >
                <img src={require("../assets/node/goal.png")} width={12} />
            </li>
        </ul>
    )
}

export default NodeAction;
